// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__kKW8o","active":"MainNavigation_active__3tTjS","header-image":"MainNavigation_header-image__cUZhT"};